//  TODO replace ExampleDynamicBlock with class name you like.
class ExampleDynamicBlock{

    static blockRootSelector = '.example-dynamic-block-class';

    constructor(el) {
        // do something with block=> init slider or whatever, add event listeners etc.
        // const $slider = jQuery('.example-slides', el); // please use selectors with parent el set, so jQuery will select only block's childs.
        // $slider.slick({
        //     // some options go here...
        // });
        // demo below.
        jQuery(el).html('<code> class ExampleDynamicBlock works </code>')


    }

    static initializeStatic(){
        //  TODO replace ExampleDynamicBlock with class name
        // now we initialize blocks of this type which are already rendered on page not via ajax.
        jQuery(ExampleDynamicBlock.blockRootSelector).each((index, el) => {

            const blockId = `wpshopify_initial_ExampleDynamicBlock_${index}`; //  TODO replace ExampleDynamicBlock with class name

            window.WPShopify.blockInstances[blockId] = {
                el: el,
                id: blockId,
                blockInitFunctionName: 'ExampleDynamicBlock', //  TODO replace ExampleDynamicBlock with class name
                instance: new ExampleDynamicBlock(el) //  TODO replace ExampleDynamicBlock with class name
            };

        });

    }

    static initializeBlock(el){
        return new ExampleDynamicBlock(el); //  TODO replace ExampleDynamicBlock with class name
    }
}

//  TODO replace ExampleDynamicBlock with class name
ExampleDynamicBlock.initializeStatic();
// save our block initializer function to storage to make it possible to init blocks of same type loaded by ajax.
//  TODO replace ExampleDynamicBlock with class name
window.WPShopify.blocksInits['ExampleDynamicBlock'] = ExampleDynamicBlock.initializeBlock;

